import { render, staticRenderFns } from "./TerminalSettingForm.vue?vue&type=template&id=3feeddec&scoped=true&"
import script from "./TerminalSettingForm.vue?vue&type=script&lang=js&"
export * from "./TerminalSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feeddec",
  null
  
)

export default component.exports